// V8.4.2 — Olive Frontend
// 基于 V8.4.1：
// 1. 修复流式重复长文本
// 2. 顶部头像改为机器人
// 3. 右下角悬浮球改为机器人
// 4. AI 回复左侧增加机器人头像

import React, { useEffect, useRef, useState } from "react";
/* global wx */

const API_BASE = window.OLIVE_CONFIG?.API_BASE_URL || "https://www.qiyiju.cn";
const OLIVE_AVATAR = "/chat/ai-avatar.png";

const INITIAL_MESSAGES = [
  {
    id: "welcome",
    role: "assistant",
    content: "您好呀～点按左下角麦克风或输入文字开始聊天",
  },
];

const Mic = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="22" />
  </svg>
);

const Send = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

const Close = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const Play = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

const ChatStyles = () => (
  <style>{`
    #qiyiju-olive-chat {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9998;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
    }

    .olive-fab {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: none;
      background: radial-gradient(circle at 30% 20%, #bbf7d0 0, #16a34a 35%, #166534 100%);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 18px 40px rgba(15, 118, 110, 0.35);
      position: relative;
      overflow: hidden;
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      padding: 0;
    }

    .olive-fab::before {
      content: "";
      position: absolute;
      inset: 0;
      background: radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4) 0, transparent 45%);
      opacity: 0.9;
      pointer-events: none;
    }

    .olive-fab-img {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      object-fit: contain;
      position: relative;
      z-index: 1;
      display: block;
      background: rgba(255, 255, 255, 0.9);
    }

    .olive-fab-close {
      display: none;
      position: relative;
      z-index: 1;
      align-items: center;
      justify-content: center;
    }

    .olive-fab.open .olive-fab-img {
      display: none;
    }

    .olive-fab.open .olive-fab-close {
      display: flex;
    }

    .olive-fab-close svg {
      position: relative !important;
      opacity: 1 !important;
      transform: none !important;
    }

    .olive-fab:hover {
      transform: translateY(-2px) scale(1.03);
      box-shadow: 0 22px 50px rgba(15, 118, 110, 0.45);
    }

    .olive-chat {
      position: absolute;
      bottom: 80px;
      right: 0;
      width: min(390px, calc(100vw - 32px));
      height: min(520px, calc(100vh - 170px));
      border-radius: 22px;
      background: linear-gradient(145deg, #f8fafc 0, #ffffff 40%, #f1f5f9 100%);
      box-shadow: 0 22px 60px rgba(15, 23, 42, 0.28);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      opacity: 0;
      visibility: hidden;
      transform: translateY(30px) scale(0.96);
      transform-origin: bottom right;
      transition:
        opacity 0.28s cubic-bezier(0.16, 1, 0.3, 1),
        visibility 0.28s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.28s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .olive-chat.open {
      opacity: 1;
      visibility: visible;
      transform: translateY(0) scale(1);
    }

    .olive-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      border-bottom: 1px solid rgba(15, 23, 42, 0.06);
      background: radial-gradient(circle at 0 0, #e0f2fe 0, #eff6ff 35%, #ffffff 70%);
    }

    .olive-avatar {
      width: 42px;
      height: 42px;
      border-radius: 999px;
      object-fit: contain;
      box-shadow: 0 10px 25px rgba(37, 99, 235, 0.25);
      border: 2px solid rgba(255, 255, 255, 0.9);
      background: #ffffff;
    }

    .olive-title-wrap {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 3px;
    }

    .olive-title {
      font-size: 16px;
      line-height: 1.2;
      font-weight: 700;
      color: #1f2933;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .olive-subtitle {
      font-size: 12px;
      line-height: 1.2;
      color: #6b7280;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .olive-status {
      font-size: 11px;
      padding: 4px 8px;
      border-radius: 999px;
      background: #ecfdf3;
      color: #15803d;
      font-weight: 500;
      white-space: nowrap;
    }

    .olive-header-actions {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
    }

    .olive-clear-btn,
    .olive-close-btn {
      border: 1px solid #e5e7eb;
      background: rgba(255, 255, 255, 0.95);
      color: #4b5563;
      cursor: pointer;
      box-shadow: none;
      transition: background-color 0.16s ease, transform 0.16s ease;
    }

    .olive-clear-btn {
      height: 26px;
      padding: 0 8px;
      border-radius: 999px;
      font-size: 12px;
      line-height: 24px;
      white-space: nowrap;
    }

    .olive-close-btn {
      width: 30px;
      height: 30px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      background: #0f172a;
      border-color: #0f172a;
    }

    .olive-clear-btn:hover,
    .olive-close-btn:hover {
      transform: translateY(-1px);
    }

    .olive-close-btn svg {
      width: 18px;
      height: 18px;
    }

    .olive-ai-notice {
      margin: 6px 12px 6px !important;
      padding: 6px 10px !important;
      border: 1px solid #dbeafe !important;
      border-radius: 10px !important;
      background: #f8fbff !important;
      color: #4b5563 !important;
      font-size: 12px !important;
      line-height: 1.45 !important;
      font-weight: 500 !important;
    }

    .olive-body {
      flex: 1;
      padding: 10px 12px 8px;
      overflow-y: auto;
      background: radial-gradient(circle at top,#f4f6fb 0,#f9fafb 45%,#f9fafb 100%);
    }

    .msg {
      display: flex;
      margin-bottom: 8px;
    }

    .msg.left {
      justify-content: flex-start;
      align-items: flex-start;
    }

    .msg.right {
      justify-content: flex-end;
    }

    .msg-avatar {
      width: 34px;
      height: 34px;
      border-radius: 999px;
      object-fit: contain;
      margin-right: 8px;
      flex-shrink: 0;
      align-self: flex-start;
      background: #ffffff;
      box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
      border: 1px solid rgba(255, 255, 255, 0.9);
    }

    .bubble {
      max-width: 82%;
      border-radius: 18px;
      padding: 9px 12px;
      font-size: 14px;
      line-height: 1.55;
      position: relative;
      display: inline-flex;
      align-items: flex-end;
      gap: 4px;
    }

    .msg.left .bubble {
      background: #ffffff;
      color: #111827;
      border-bottom-left-radius: 4px;
      box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
    }

    .msg.right .bubble {
      background: linear-gradient(135deg, #4ade80, #16a34a);
      color: white;
      border-bottom-right-radius: 4px;
      box-shadow: 0 10px 22px rgba(22, 163, 74, 0.55);
    }

    .olive-message {
      white-space: pre-wrap;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .bubble-stream {
      background: #ffffff;
      color: #111827;
      border-radius: 16px;
      padding: 9px 12px;
      box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
      position: relative;
    }

    .bubble-stream::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 16px;
      background: linear-gradient(90deg, rgba(59,130,246,.06), transparent);
      pointer-events: none;
    }

    .speak-btn {
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 2px 0 0 2px;
      display: inline-flex;
      align-items: center;
      opacity: 0.55;
      transition: opacity 0.15s ease, transform 0.15s ease;
    }

    .speak-btn:hover {
      opacity: 1;
      transform: translateY(-1px);
    }

    .speak-btn.active {
      opacity: 1;
      color: #16a34a;
    }

    .olive-input {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 12px 12px;
      border-top: 1px solid rgba(15, 23, 42, 0.06);
      background: linear-gradient(180deg, #f9fafb 0, #f3f4f6 40%, #eef2ff 100%);
    }

    .olive-input input {
      flex: 1;
      border-radius: 999px;
      border: 1px solid #d1d5db;
      font-size: 14px;
      padding: 9px 12px;
      outline: none;
      background: rgba(255, 255, 255, 0.98);
      transition: border-color 0.16s ease, box-shadow 0.16s ease;
    }

    .olive-input input:focus {
      border-color: #4f46e5;
      box-shadow: 0 0 0 1px rgba(79, 70, 229, 0.35);
    }

    .mic-btn,
    .send-btn {
      width: 40px;
      height: 40px;
      border-radius: 999px;
      border: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: white;
      box-shadow: 0 6px 18px rgba(15, 23, 42, 0.18);
      transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
    }

    .mic-btn.rec {
      background: #fee2e2;
      color: #b91c1c;
      box-shadow: 0 8px 22px rgba(185, 28, 28, 0.45);
    }

    .send-btn {
      background: linear-gradient(135deg, #4f46e5, #6366f1);
      color: #fff;
      box-shadow: 0 10px 24px rgba(79, 70, 229, 0.5);
    }

    .mic-btn:hover,
    .send-btn:hover {
      transform: translateY(-1px);
    }

    @media (max-width: 480px) {
      #qiyiju-olive-chat {
        bottom: 0;
        right: 0;
        width: 100%;
      }

      .olive-chat {
        position: fixed;
        inset: 0;
        width: 100%;
        height: 100%;
        max-height: none;
        border-radius: 0;
      }

      .olive-fab {
        position: fixed;
        right: 18px;
        bottom: 20px;
      }

      .olive-fab.open {
        bottom: calc(90px + env(safe-area-inset-bottom));
      }

      .olive-input {
        padding-bottom: calc(10px + env(safe-area-inset-bottom));
      }
    }
  `}</style>
);

const SR = window.SpeechRecognition || window.webkitSpeechRecognition || null;
const inWeChat = () => /micromessenger/i.test(navigator.userAgent);

function tryParseJson(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function readCookie(name) {
  const parts = document.cookie ? document.cookie.split(/;\s*/) : [];
  for (const part of parts) {
    const idx = part.indexOf("=");
    if (idx < 0) continue;
    const key = part.slice(0, idx);
    if (key !== name) continue;
    try {
      return decodeURIComponent(part.slice(idx + 1));
    } catch {
      return part.slice(idx + 1);
    }
  }
  return "";
}

function getAuthToken() {
  const storageKeys = [
    "qy_miniapi_token",
    "qiyiju_ai_jwt",
    "accessToken",
    "token",
    "authToken",
    "authorized-token",
    "authorizedToken",
  ];

  for (const store of [window.localStorage, window.sessionStorage]) {
    for (const key of storageKeys) {
      try {
        const value = store.getItem(key);
        if (!value) continue;
        const parsed = tryParseJson(value);
        const token = parsed?.accessToken || parsed?.token || value;
        if (typeof token === "string" && token.split(".").length === 3) {
          return token.trim();
        }
      } catch {}
    }
  }

  const cookieValue = readCookie("authorized-token");
  const parsedCookie = cookieValue ? tryParseJson(cookieValue) : null;
  const cookieToken = parsedCookie?.accessToken || parsedCookie?.token || "";
  return typeof cookieToken === "string" && cookieToken.split(".").length === 3
    ? cookieToken.trim()
    : "";
}

export default function App() {
  const [open, setOpen] = useState(false);

  const [messages, setMessages] = useState(() => {
    try {
      const saved = localStorage.getItem("olive_msgs");
      return saved ? JSON.parse(saved) : INITIAL_MESSAGES;
    } catch {
      return INITIAL_MESSAGES;
    }
  });

  const [input, setInput] = useState("");
  const [status, setStatus] = useState("访客模式");
  const [streamingText, setStreamingText] = useState("");
  const [recording, setRecording] = useState(false);
  const [speakingId, setSpeakingId] = useState(null);

  const endRef = useRef(null);
  const recogRef = useRef(null);
  const esRef = useRef(null);
  const streamRef = useRef("");

  useEffect(() => {
    try {
      localStorage.setItem("olive_msgs", JSON.stringify(messages));
    } catch {}
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, streamingText]);

  useEffect(() => {
    if (!SR) return;
    const r = new SR();
    r.lang = "zh-CN";
    r.onstart = () => setRecording(true);
    r.onend = () => setRecording(false);
    r.onresult = (e) => {
      const t = e.results?.[0]?.[0]?.transcript || "";
      if (t) send(t);
    };
    recogRef.current = r;
  }, []);

  useEffect(() => {
    if (!inWeChat()) return;
    (async () => {
      try {
        const url = encodeURIComponent(window.location.href.split("#")[0]);
        const sig = await fetch(
          `${API_BASE}/api/wechat-signature?url=${url}`,
          { credentials: "include" }
        ).then((r) => r.json());
        if (!sig?.appId) return;
        wx.config({
          debug: false,
          appId: sig.appId,
          timestamp: sig.timestamp,
          nonceStr: sig.nonceStr,
          signature: sig.signature,
          jsApiList: ["startRecord", "stopRecord", "onVoiceRecordEnd", "translateVoice"],
        });
      } catch (e) {
        console.log("wx sig fail", e);
      }
    })();
  }, []);

  const toggleSpeak = (id, text) => {
    if (!window.speechSynthesis || !text) return;
    const synth = window.speechSynthesis;

    if (speakingId === id && synth.speaking) {
      synth.cancel();
      setSpeakingId(null);
      return;
    }

    synth.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "zh-CN";
    u.onend = () => setSpeakingId(null);
    setSpeakingId(id);
    synth.speak(u);
  };

  const clearMessages = () => {
    if (!window.confirm("确定要清空当前对话记录吗？")) return;

    if (window.speechSynthesis && window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }

    if (esRef.current) {
      try { esRef.current.close(); } catch {}
      esRef.current = null;
    }

    setMessages(INITIAL_MESSAGES);
    setStreamingText("");
    streamRef.current = "";

    try {
      localStorage.removeItem("olive_msgs");
    } catch {}
  };

  const send = (textOpt) => {
    const content = (textOpt ?? input).trim();
    if (!content) return;

    if (esRef.current) {
      try {
        esRef.current.close();
      } catch {}
      esRef.current = null;
    }

    const id = `u_${Date.now()}`;
    setMessages((prev) => [...prev, { id, role: "user", content }]);
    setInput("");
    setStreamingText("");
    streamRef.current = "";

    (async () => {
      try {
        const token = getAuthToken();
        const headers = { "Content-Type": "application/json" };
        if (token) headers.Authorization = `Bearer ${token}`;

        const r = await fetch(`${API_BASE}/miniapi/ai/chat`, {
          method: "POST",
          headers,
          credentials: "include",
          body: JSON.stringify({
            message: content,
            source: "web",
            context_url: window.location.href,
          }),
        });
        const j = await r.json();
        let reply = j?.data?.reply || "";
        if (r.status === 401) {
          reply = "请先登录后使用橄榄 AI";
          setStatus("访客模式");
        } else if (r.status === 403) {
          reply = "当前账号暂不能使用 AI，请确认已完成会员/年龄认证";
          setStatus("访客模式");
        } else if (r.ok) {
          setStatus("会员");
        }
        if (!reply) reply = "（抱歉，橄榄这次没听清～）";
        const id2 = `a_${Date.now()}`;
        setMessages((prev) => [
          ...prev,
          { id: id2, role: "assistant", content: reply },
        ]);
      } catch (e) {
        const id2 = `a_${Date.now()}`;
        setMessages((prev) => [
          ...prev,
          {
            id: id2,
            role: "assistant",
            content: "网络好像有点问题，稍后再试试～",
          },
        ]);
      }
    })();
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  const toggleRec = () => {
    if (inWeChat() && typeof wx !== "undefined") {
      wx.ready(() => {
        if (!recording) {
          wx.startRecord({
            success: () => setRecording(true),
            cancel: () =>
              setMessages((prev) => [
                ...prev,
                {
                  id: `a_${Date.now()}`,
                  role: "assistant",
                  content: "请开启麦克风权限～",
                },
              ]),
          });
          wx.onVoiceRecordEnd({
            complete: (res) => {
              const localId = res.localId;
              wx.translateVoice({
                localId,
                isShowProgressTips: 0,
                success: (r) => {
                  const t = (r.translateResult || "").trim();
                  if (t) send(t);
                },
              });
            },
          });
        } else {
          wx.stopRecord({
            success: (res) => {
              const localId = res.localId;
              wx.translateVoice({
                localId,
                isShowProgressTips: 0,
                success: (r) => {
                  const t = (r.translateResult || "").trim();
                  if (t) send(t);
                },
              });
              setRecording(false);
            },
          });
        }
      });
      return;
    }

    const r = recogRef.current;
    if (!r) {
      setMessages((prev) => [
        ...prev,
        {
          id: `a_${Date.now()}`,
          role: "assistant",
          content:
            "当前浏览器不支持语音输入，可以尝试在微信内或使用 Chrome 浏览器打开再试试～",
        },
      ]);
      return;
    }

    if (recording) r.stop();
    else {
      try {
        r.start();
      } catch {}
    }
  };

  return (
    <div className="qiyiju-olive-app">
      <ChatStyles />
      <div className={`olive-chat ${open ? "open" : ""}`}>
        <div className="olive-header">
          <img
            className="olive-avatar"
            src={OLIVE_AVATAR}
            alt="橄榄"
          />
          <div className="olive-title-wrap">
            <div className="olive-title">AI伙伴「橄榄」</div>
            <div className="olive-subtitle">温暖陪伴 · 智慧守护</div>
          </div>
          <div className="olive-header-actions">
            <div className="olive-status">{status}</div>
            <button
              type="button"
              className="olive-clear-btn"
              onClick={clearMessages}
            >
              清空
            </button>
            <button
              type="button"
              className="olive-close-btn"
              onClick={() => setOpen(false)}
              aria-label="关闭橄榄"
            >
              <Close />
            </button>
          </div>
        </div>

        <div
          className="olive-ai-notice"
          style={{
            margin: "8px 18px 0",
            padding: "6px 10px",
            border: "1px solid #dbeafe",
            borderRadius: 10,
            background: "#f8fbff",
            color: "#4b5563",
            fontSize: 12,
            lineHeight: 1.45,
            fontWeight: 500
          }}
        >
          本服务为AI生成内容，结果仅供参考，请以平台实际页面信息为准
        </div>

        <div className="olive-body">
          {messages.map((m) => (
            <div
              key={m.id}
              className={`msg ${m.role === "user" ? "right" : "left"}`}
            >
              {m.role === "assistant" && (
                <img className="msg-avatar" src={OLIVE_AVATAR} alt="橄榄" />
              )}

              <div className="bubble">
                <div className="olive-message">{m.content}</div>
                {m.role === "assistant" && (
                  <button
                    className={`speak-btn ${
                      speakingId === m.id ? "active" : ""
                    }`}
                    onClick={() => toggleSpeak(m.id, m.content)}
                    title={speakingId === m.id ? "停止朗读" : "朗读这条回复"}
                  >
                    <Play />
                  </button>
                )}
              </div>
            </div>
          ))}

          {streamingText && (
            <div className="msg left">
              <img className="msg-avatar" src={OLIVE_AVATAR} alt="橄榄" />
              <div className="bubble bubble-stream">
                <div className="olive-message">{streamingText}</div>
              </div>
            </div>
          )}

          <div ref={endRef} />
        </div>

        <div className="olive-input">
          <button
            className={`mic-btn ${recording ? "rec" : ""}`}
            onClick={toggleRec}
          >
            <Mic />
          </button>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={onKey}
            placeholder="输入或语音与橄榄聊天，AI内容仅供参考"
          />
          <button className="send-btn" onClick={() => send()}>
            <Send />
          </button>
        </div>
      </div>

      {!open && (
        <button
          className="olive-fab"
          onClick={() => setOpen(true)}
          aria-label="打开橄榄"
        >
          <img className="olive-fab-img" src={OLIVE_AVATAR} alt="橄榄" />
        </button>
      )}
    </div>
  );
}
